// extracted by mini-css-extract-plugin
export default {"pillars":"PillarGrid_pillars__JuiP6","pillar":"PillarGrid_pillar__mWxA9"};